import { useCallback, useState } from "react"
import { Box } from "@chakra-ui/react"

import {
  selectDepositFromAnotherWallet,
  selectDepositStatus,
  setDepositModalClosed,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import ModalContainer from "#/shared/components/ModalContainer"
import { MezoModalProps } from "#/shared/types"

import DepositModalIncoming from "./DepositModalIncoming"
import DepositModalReceiptFromAnotherWallet from "./DepositModalReceiptFromAnotherWallet"
import DepositModalReceiptFromCurrentWallet from "./DepositModalReceiptFromCurrentWallet"

export default function DepositModal({ isOpen, onClose }: MezoModalProps) {
  const depositFromAnotherWallet = useDappSelector(
    selectDepositFromAnotherWallet,
  )

  const depositStatus = useDappSelector(selectDepositStatus)
  const dispatch = useDappDispatch()

  const [confirmModalClose, setConfirmModalClose] = useState(false)

  const showClosingModal = confirmModalClose && depositStatus !== "completed"

  const modalCloseHandler = useCallback(() => {
    if (depositStatus === "completed") {
      dispatch(setDepositModalClosed(true))
      onClose()
    } else {
      setConfirmModalClose(true)
    }
  }, [depositStatus, dispatch, onClose])

  const modalLeaveHandler = useCallback(() => {
    onClose()
    setConfirmModalClose(false)
  }, [onClose])

  const receiptContent = depositFromAnotherWallet ? (
    <DepositModalReceiptFromAnotherWallet
      close={modalLeaveHandler}
      showClosingModal={showClosingModal}
      setConfirmModalClose={setConfirmModalClose}
    />
  ) : (
    <DepositModalReceiptFromCurrentWallet
      close={modalLeaveHandler}
      showClosingModal={showClosingModal}
      setConfirmModalClose={setConfirmModalClose}
    />
  )

  const modalContent =
    depositStatus === "completed" ? <DepositModalIncoming /> : receiptContent

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={modalCloseHandler}
      width={confirmModalClose ? "669px" : "572px"}
      isCentered={false}
      props={{ mt: "90px" }}
    >
      <Box bg="primary.white.100" px="72px" py="56px" rounded="24px">
        {modalContent}
      </Box>
    </ModalContainer>
  )
}
